<template>
  <Dialog v-model="dialogVisible" title="指定股东" width="520px">
    <el-form ref="formRef" v-loading="formLoading" :model="formData" :rules="formRules" label-width="90px">
      <el-form-item label="会员" prop="userId">
        <el-select
          v-model="formData.userId"
          class="w-1/1"
          clearable
          filterable
          remote
          reserve-keyword
          placeholder="输入编号或昵称搜索会员"
          :remote-method="debouncedSearch"
          :loading="searchLoading"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="`${item.id} - ${item.nickname || '未命名'}`"
            :value="item.id"
          />
        </el-select>
        <div class="el-form-item__tip">须已是分销商，否则接口会拒绝</div>
      </el-form-item>
      <el-form-item label="等级" prop="levelId">
        <el-select v-model="formData.levelId" class="w-1/1" clearable placeholder="默认等级可不选">
          <el-option v-for="l in levels" :key="l.id" :label="l.name" :value="l.id" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submit">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import * as UserApi from '@/api/mall/trade/shareholder/user'
import * as LevelApi from '@/api/mall/trade/shareholder/level'
import * as MemberUserApi from '@/api/member/user'

defineOptions({ name: 'ShareholderUserCreateForm' })

const emit = defineEmits(['success'])
const message = useMessage()
const dialogVisible = ref(false)
const formLoading = ref(false)
const searchLoading = ref(false)
const options = ref<MemberUserApi.UserVO[]>([])
const levels = ref<LevelApi.ShareholderLevelSimpleVO[]>([])
const formRef = ref()
const formData = ref<{ userId?: number; levelId?: number }>({})
const formRules = reactive({
  userId: [{ required: true, message: '请选择会员', trigger: 'change' }]
})

let timer: ReturnType<typeof setTimeout> | null = null
const debouncedSearch = (query: string) => {
  if (timer) clearTimeout(timer)
  timer = setTimeout(async () => {
    if (!query) {
      options.value = []
      return
    }
    searchLoading.value = true
    try {
      const data = await MemberUserApi.getUserPage({
        pageNo: 1,
        pageSize: 20,
        nickname: /^\d+$/.test(query) ? undefined : query,
        id: /^\d+$/.test(query) ? Number(query) : undefined
      } as any)
      options.value = data.list || []
    } finally {
      searchLoading.value = false
    }
  }, 300)
}

const open = async () => {
  dialogVisible.value = true
  formData.value = {}
  levels.value = (await LevelApi.getShareholderLevelSimpleList()) || []
  await nextTick()
  formRef.value?.resetFields()
}

const submit = async () => {
  await formRef.value?.validate()
  formLoading.value = true
  try {
    await UserApi.createShareholderUser({
      userId: formData.value.userId!,
      levelId: formData.value.levelId
    })
    message.success('指定成功')
    dialogVisible.value = false
    emit('success')
  } finally {
    formLoading.value = false
  }
}

defineExpose({ open })
</script>
